import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useRouter } from '@tanstack/react-router';

import { backendApiAuthenticationLogout } from '@/modules/api/backend';

export function useLogout() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const router = useRouter();

  return {
    logout: async () => {
      await backendApiAuthenticationLogout();
      await queryClient.invalidateQueries();
      await navigate({ to: '/' });
      await router.invalidate();
    },
  };
}
